window.addEventListener('DOMContentLoaded', () => {
    let dropdown = document.getElementById('wp-block-categories-1');
    if (dropdown) {
        dropdown.addEventListener('change', onCatChange);

    }

    function onCatChange() {
        let selectedValue = dropdown.options[dropdown.selectedIndex].value;

        if (selectedValue == -1) {
            location.href = "/tous-les-articles/";
        } else if (selectedValue > 0) {
            location.href = "/?cat=" + selectedValue;
        }
    }
});
